import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Form from './Form';

class Edit extends Component {
  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
      dealershipBlacklist,
    } = this.props;

    return (
      <Form
        isModalOpen={isModalOpen}
        onCloseHandler={onCloseHandler}
        onSubmitHandler={onSubmitHandler}
        error={error}
        submitting={submitting}
        dealershipBlacklist={dealershipBlacklist}
        action='edit'
      />
    );
  }
}

Edit.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  dealershipBlacklist: PropTypes.object.isRequired,
};

export default Edit;
